import {useState} from "react";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";
import {CompanyExtensionEntity} from "@dropDesk/domain/entities/plan_extensions/company_extension.entity";
import {PlanExtensionSimulateHireEntity} from "@dropDesk/domain/entities/plan_extensions/plan_extension_simulate_hire.entity";

export const useModalsSubscription = () => {

    const [visibleModalPay, setVisibleModalPay] = useState<{ visible: boolean; isTrial: boolean }>({ visible: false, isTrial: false });
    const [visibleModalDisplayDataPix, setVisibleModalDisplayDataPix] = useState<{
        visible: boolean
        payment?: PaymentEntity,
    }>({visible: false});
    const [visibleModalDisplayBoleto, setVisibleModalDisplayBoleto] = useState<{
        visible: boolean
        payment?: PaymentEntity,
    }>({visible: false});
    const [visibleModalProcessingCreditCardPayment, setVisibleModalProcessingCreditCardPayment] = useState<{
        visible: boolean
        payment?: PaymentEntity,
    }>({visible: false});
    const [visibleModalRejectedCreditCardPayment, setVisibleModalRejectedCreditCardPayment] = useState<{
        visible: boolean
        payment?: PaymentEntity,
    }>({visible: false});
    const [visibleModalPaymentSuccess, setVisibleModalPaymentSuccess] = useState<boolean>(false);
    const [visibleModalChangePaymentInfo, setVisibleModalChangePaymentInfo] = useState<boolean>(false);
    const [visibleModalChangePaymentMethod, setVisibleModalChangePaymentMethod] = useState<boolean>(false);
    const [visibleModalReactiveSubscription, setVisibleModalReactiveSubscription] = useState<boolean>(false);
    const [visibleModalCancelSubscription, setVisibleModalCancelSubscription] = useState<boolean>(false);
    const [visibleModalLogout, setVisibleModalLogout] = useState<boolean>(false);
    const [visibleModalCancelFutureSubscription, setVisibleModalCancelFutureSubscription] = useState<boolean>(false);
    const [visibleModalDowngrade, setVisibleModalDowngrade] = useState<boolean>(false);
    const [visibleModalViewLog, setVisibleModalViewLog] = useState<boolean>(false);
    const [visibleModalCancelExtension, setVisibleModalCancelExtension] = useState<{
        visible: boolean,
        extension: CompanyExtensionEntity | null
    }>({visible: false, extension: null});

    const [visibleModalReactivateExtension, setVisibleModalReactivateExtension] = useState<{
        visible: boolean,
        extension: CompanyExtensionEntity | null
    }>({visible: false, extension: null});

    const [visibleModalExtensionTrialSuccess, setVisibleModalExtensionTrialSuccess] = useState<{
        visible: boolean,
        simulate: PlanExtensionSimulateHireEntity | null
    }>({visible: false, simulate: null});

    return {
        visibleModalPay, setVisibleModalPay,
        visibleModalDisplayDataPix, setVisibleModalDisplayDataPix,
        visibleModalDisplayBoleto, setVisibleModalDisplayBoleto,
        visibleModalProcessingCreditCardPayment, setVisibleModalProcessingCreditCardPayment,
        visibleModalPaymentSuccess, setVisibleModalPaymentSuccess,
        visibleModalChangePaymentInfo, setVisibleModalChangePaymentInfo,
        visibleModalChangePaymentMethod, setVisibleModalChangePaymentMethod,
        visibleModalReactiveSubscription, setVisibleModalReactiveSubscription,
        visibleModalCancelSubscription, setVisibleModalCancelSubscription,
        visibleModalLogout, setVisibleModalLogout,
        visibleModalCancelFutureSubscription, setVisibleModalCancelFutureSubscription,
        visibleModalDowngrade, setVisibleModalDowngrade,
        visibleModalViewLog, setVisibleModalViewLog,
        visibleModalRejectedCreditCardPayment, setVisibleModalRejectedCreditCardPayment,
        visibleModalCancelExtension, setVisibleModalCancelExtension,
        visibleModalReactivateExtension, setVisibleModalReactivateExtension,
        visibleModalExtensionTrialSuccess, setVisibleModalExtensionTrialSuccess,
    }
}
